import { Alert, Collapse } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { tierConfigToViewModel } from '../../../schemas/FundWaterfall.schema';
import { cardStyles } from '../../../theme/component-styles';
import { plainDateFromDateOrDateString } from '../../../util/date-utilts';
import { selectedDateFPState, selectedFundIdStateFP, waterfallConfigDisplayState } from '../state/FPState';
import { waterfallDataAtom } from './FPWaterfallData3';
import { useWaterfallConfig } from './useWaterfallConfig';
import { WaterfallFormulasConfig } from './WaterfallFormulasConfig';
import { WaterfallResultsGrid } from './WaterfallResultsGrid';
import { WaterfallTiersConfig } from './WaterfallTiersConfig';

export function WaterfallModellingGrid3() {
  const configDisplay = useAtomValue(waterfallConfigDisplayState);
  const fundId = useAtomValue(selectedFundIdStateFP);
  const selectedDate = useAtomValue(selectedDateFPState);
  const waterfallData = useAtomValue(
    waterfallDataAtom({
      fundId: fundId ?? -1,
      asOfDate: plainDateFromDateOrDateString(selectedDate),
    })
  );
  const tiers = useMemo(() => {
    return Object.values(waterfallData.data?.configuration.tiers ?? {}).map((tier) =>
      tierConfigToViewModel(tier)
    );
  }, [waterfallData.data?.configuration.tiers]);

  const { updateWaterfallTiers } = useWaterfallConfig();

  return (
    <div>
      {waterfallData.data?.message && (
        <Alert severity='error' sx={{ mb: '0.5rem' }}>
          {waterfallData.data.message}
        </Alert>
      )}
      {!waterfallData.data?.message && (
        <div style={cardStyles}>
          <WaterfallResultsGrid />
        </div>
      )}
      <Collapse in={configDisplay === 'calcs'}>
        {configDisplay === 'calcs' ? <WaterfallFormulasConfig /> : <div style={{ height: '10rem' }} />}
      </Collapse>
      <Collapse in={configDisplay === 'tiers'}>
        {configDisplay === 'tiers' ? (
          <WaterfallTiersConfig key={fundId} tiers={tiers} onSave={updateWaterfallTiers} />
        ) : (
          <div style={{ height: '10rem' }} />
        )}
      </Collapse>
    </div>
  );
}
